import React, { useState } from "react";
import {
	getColorByNumber,
	partiallyHideHash,
	pxToRem,
	toNumberFixed,
} from "@/util/common";
import { createUseStyles } from "react-jss";
import useCustomStyles from "@/hooks/useCustomStyles";
import { Button, Grid, Skeleton } from "antd-mobile";
import useCenterPopup from "@/hooks/useCenterPopup";
import PlayerAddress from "./PlayerAddress";
import Remark from "./Remark";
import { isEmpty } from "lodash";
import useRouter from "@/hooks/useRouter";
import { RootState } from "@/redux/store";
import { useSelector } from "react-redux";
import useCustomTranslation from "@/hooks/useTranslation";

const TinyChen: React.FC<{
	data: Record<string, any>;
	isOperate?: boolean;
	index: number;
}> = ({ data, isOperate = true, index }) => {
	const classes = useStyles();
	const useClasses = useCustomStyles();
	const { t } = useCustomTranslation();
	const { userInfo } = useSelector((state: RootState) => state.auth);
	const PlayerAddressPopup = useCenterPopup();
	const RemarkPopup = useCenterPopup();
	const { customNavigate } = useRouter();
	const buttonsData = [
		{
			name: t("Remark"),
			key: "remark",
		},
		{
			name: t("Gift"),
			key: "gift",
		},
		{
			name: t("GameRecord"),
			key: "game",
		},
		{
			name: t("DepositRecord"),
			key: "deposit",
		},
	];

	let settingData: Record<string, any> = {};
	const setting = data.setting;
	if (!isEmpty(setting) && setting) {
		settingData = JSON.parse(setting);
	}

	const menuLinkHandle = (key: string) => {
		switch (key) {
			case "remark":
				RemarkPopup.showPopup();
				break;
			case "gift":
				PlayerAddressPopup.showPopup();
				break;
			case "game": {
				const outerParams = {
					nickname: data["nickname"],
					walletAddress: data["walletAddress"],
					inviteRemake: data["inviteRemake"],
				};
				customNavigate(
					"/personnal-game-records" +
						"/" +
						data["uid"] +
						"/" +
						JSON.stringify(outerParams)
				);
				break;
			}
			case "deposit": {
				const outerParams = {
					nickname: data["nickname"],
					walletAddress: data["walletAddress"],
					inviteRemake: data["inviteRemake"],
				};
				customNavigate(
					"/personnal-records" +
						"/" +
						data["uid"] +
						"/" +
						JSON.stringify(outerParams)
				);
				break;
			}
		}
	};

	const AllEarningHandle = () => {
		const rusult = getColorByNumber(data.earning);
		if (rusult === "win") {
			return "+" + toNumberFixed(data.earning, 2);
		} else if (rusult === "lose") {
			return toNumberFixed(data.earning, 2);
		}
		return "0";
	};

	const userStatusHandle = (status: number) => {
		// 1/有效 0/无效
		let result = t("Invalid");
		if (status === 1) {
			result = t("Normal");
		}
		return result;
	};

	const getWaterPlanNameHandle = () => {
		let result = t("Default");
		const waterPlan = userInfo?.waterPlan || {};
		let indexValue = 1;
		if (!isEmpty(waterPlan)) {
			for (const key in waterPlan) {
				if (key === settingData.time) {
					result = t("Plan") + " " + indexValue;
				}
				indexValue += 1;
			}
		}
		return result;
	};
	return (
		<div className={`${useClasses.cardWrap} ${classes.tinyChenWrap}`}>
			<div className="head">
				<div className="l">{data.nickname}</div>
				<div className="r">
					<span>{t("Status")}</span>
					<span className="c8BFF78">
						{userStatusHandle(+data.status)}
					</span>
				</div>
			</div>
			{/* {
          "uid": 2,
          "balance": 980,
          "effective": 90,
          "earning": 60,
          "finalTime": "2024-05-02 12:11:16.924",
          "firstTime": "2024-05-01 13:32:35.825",
          "walletAddress": "0x222",
          "createTime": "2024-05-01 10:59:51",
          "lastOnlineTime": "2024-05-01 10:59:52",
          "status": "1"
        } */}
			<Grid columns={2} gap={[0, 16]}>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("Address")}</dt>
						{!isEmpty(data) ? (
							<dd>{partiallyHideHash(data.walletAddress)}</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("Balance")}</dt>
						{!isEmpty(data) ? (
							<dd>{toNumberFixed(data.balance, 2)}</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("EffectiveWaget")}</dt>
						{!isEmpty(data) ? (
							<dd>{toNumberFixed(data.effective, 2)}</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("AllEarning")}</dt>
						{!isEmpty(data) ? (
							<dd>{AllEarningHandle()}</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("FinalWagetTime")}</dt>
						{!isEmpty(data) ? (
							<dd className="tinydd">{data.finalTime || "-"}</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("FirstWagetTime")}</dt>
						{!isEmpty(data) ? (
							<dd className="tinydd">{data.firstTime || "-"}</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("SignTime")}</dt>
						{!isEmpty(data) ? (
							<dd className="tinydd">{data.createTime || "-"}</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("LastLoginTime")}</dt>
						{!isEmpty(data) ? (
							<dd className="tinydd">
								{data.lastOnlineTime || "-"}
							</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("MonthlyTotalReturnWater")}</dt>
						{!isEmpty(data) ? (
							<dd className="win">
								{data.monthReturnWater || "-"}
							</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("Remark")}</dt>
						{!isEmpty(data) ? (
							<dd className="tinydd">
								{data.inviteRemake || "-"}
							</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
			</Grid>
			{isOperate && (
				<div className={classes.buttonsWrap}>
					<Grid columns={2} gap={[15, 8]}>
						<Grid.Item></Grid.Item>
						<Grid.Item>
							<Button
								onClick={() => {
									const params: any = {
										uid: data.uid,
									};
									const idDefault =
										getWaterPlanNameHandle() !==
										t("Default");
									if (
										!isEmpty(settingData) &&
										settingData &&
										idDefault
									) {
										params["time"] = settingData.time;
									}
									customNavigate(
										"/manage-plan?user=" +
											JSON.stringify(params)
									);
								}}
								block
								shape="rounded"
								fill="outline"
								style={{
									fontSize: pxToRem(14),
									fontWeight: "400",
									"--text-color": "#82E8FF",
									"--background-color": "#1E212B",
									"--border-color": "#2F3A62",
								}}
							>
								{getWaterPlanNameHandle()}
							</Button>
						</Grid.Item>
						{buttonsData.map((item, index) => {
							return (
								<Grid.Item key={index}>
									<Button
										onClick={() => menuLinkHandle(item.key)}
										block
										shape="rounded"
										fill="outline"
										style={{
											fontSize: pxToRem(14),
											fontWeight: "400",
											"--text-color": "#82E8FF",
											"--background-color": "transparent",
											"--border-color": "#4C66C7",
										}}
									>
										{item.name}
									</Button>
								</Grid.Item>
							);
						})}
					</Grid>
				</div>
			)}
			<PlayerAddressPopup.PopupComp
				visible={PlayerAddressPopup.visiblePopup}
				onClose={PlayerAddressPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					PlayerAddressPopup.closePopup();
				}}
				className="centerPopupAfoot"
				style={{ "--max-width": "100vw" }}
			>
				<PlayerAddress
					onVisiblePopup={PlayerAddressPopup.closePopup}
					data={data}
				/>
			</PlayerAddressPopup.PopupComp>

			<RemarkPopup.PopupComp
				visible={RemarkPopup.visiblePopup}
				onClose={RemarkPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					RemarkPopup.closePopup();
				}}
				className="centerPopupAfoot"
				style={{ "--max-width": "100vw" }}
			>
				<Remark onVisiblePopup={RemarkPopup.closePopup} data={data} />
			</RemarkPopup.PopupComp>
		</div>
	);
};

export default TinyChen;

const useStyles = createUseStyles({
	tinyChenWrap: {
		padding: {
			left: pxToRem(18),
			right: pxToRem(18),
			top: pxToRem(15),
			bottom: pxToRem(15),
		},
	},
	buttonsWrap: {
		padding: {
			top: pxToRem(18),
		},
	},
});
